const React = require('react')
const {
  RootWrap,
} = require('./src/components/root-with-sonner')

exports.wrapRootElement = ({ element }) =>
  React.createElement(RootWrap, { element })
